export default __webpack_public_path__ + "media/zurb/img/home/home-insight-img1-fb1287815bd16df35b759bd9ca2cd1a1.png";